import { useSelector } from 'react-redux';
const useIsMarketingAdmin = () => {
    const user = useSelector((s) => s.user);
    // A loaded status stays authoritative through token-refresh refetches (isLoading) and
    // their failures (error is never cleared by the reducer); otherwise the app unmounts.
    if (user?.status?.getStatusTimestamp) {
        return user.status.is_marketing_admin === true ? 'allowed' : 'denied';
    }
    if (user?.error && !user.isLoading)
        return 'denied';
    return 'pending';
};
export default useIsMarketingAdmin;
